import cn from 'classnames';
import styles from './Tickets.module.scss';
import { TicketsType } from '@/types';
import { Ticket } from './Ticket';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';
import { SwiperButton } from '../SliderBlock';
import { useState } from 'react';
import { useAdaptiveWidth } from '@/hooks/useAdaptiveWidth';

type TicketsProps = {
  title: string;
  tickets: TicketsType[];
  className?: string;
  cardClassName?: string;
};

export function Tickets({
  title,
  tickets,
  className,
  cardClassName,
}: TicketsProps) {
  const ticketsClassName = cn(styles.tickets, className);
  const { isMobile } = useAdaptiveWidth();
  const [isStart, setIsStart] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const handleSlideChange = (swiper: SwiperClass) => {
    setIsStart(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  if (tickets.length <= 0) return null;

  const ticketSize = tickets.length > 3 ? 'medium' : 'big';

  return (
    <div className={ticketsClassName}>
      <Swiper
        slidesPerView="auto"
        spaceBetween={tickets.length > 3 ? 12 : 16}
        className={styles.sliderDefault}
        freeMode
        modules={[FreeMode]}
        onSlideChange={handleSlideChange}
      >
        <div className={styles.header}>
          {title && (
            <h3 className={cn(styles.title, 'custom-tickets-title')}>
              {title}
            </h3>
          )}
          {!isMobile && tickets.length > 4 && (
            <div className={styles.buttons}>
              <SwiperButton disabled={isStart} />
              <SwiperButton disabled={isEnd} isNextButton />
            </div>
          )}
        </div>
        {tickets.map(
          (
            { id, name, text, help, price, numberOfPersons, button, link },
            index,
          ) => (
            <SwiperSlide key={`${name}-${index}`} className="custom-slide">
              <Ticket
                key={id}
                id={id}
                name={name}
                text={text}
                help={help}
                price={price}
                numberOfPersons={numberOfPersons}
                button={button}
                link={link}
                size={ticketSize}
                className={cardClassName}
              />
            </SwiperSlide>
          ),
        )}
      </Swiper>
    </div>
  );
}
